<template>
  <div class="background-01">
    <div aria-hidden="true">
      <v-layout row wrap justify-center class="animated fadeInUp">
        <ui-title-red textTitle="Actividad"></ui-title-red>
        <v-flex xs12 class="text-xs-center">
          <ui-simple-lsc @hideVideo="hideVideo" :vidTittle="'Actividad'" videoEmbed="ADMINISTRACIONDINERO10Actividad  (ant41).mp4"></ui-simple-lsc>
        </v-flex>
        <v-flex xs12 md2>
          <image-app :imaSize="200" imaSrc="design/banco4-3-2" imaAlt=""></image-app>
        </v-flex>      
        <v-flex xs12 md10>
          <p>
            ¿Qué decisiones adicionales puede tomar Juliana para estar más cerca de alcanzar su meta?<br>
            <strong>Seleccione una decisión y arrástrela hasta la opción que corresponda:</strong>
          </p>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center>

        <v-flex xs12 sm6 md7 class="animated fadeInLeft dura_1">
          <div class="table-drop-act adorn-left">
            <v-layout  row wrap v-for="(dropper, index) in droppers" :key="index">
              <v-flex xs12 md6>
                <p> 
                  {{listaDrop[index]}}
                </p>
              </v-flex>
              <v-flex xs12 md6 text-xs-center>
                <draggable class="drop aligner" :move="checkMove" :list="dropper" v-model="dropper.name" :options="{group:{ name:'opciones',  pull:true, put:dropper.length < 1?true:false}}">
                  <div v-for="(element, index) in dropper" :key="'drop'+index">
                    <p :class="element.resp">
                      {{element.name}}
                    </p>
                  </div>
                </draggable>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>

        <v-flex xs12 sm6 md4 text-xs-center class="animated fadeInUp dura_1">

          <div v-if="retro" class="retro">
            <template v-for="(item, index) in listOri">
              <p role="alert" v-if="item.name === retro.name" :key="index" class="animated fadeInUp font-red">{{retro.retroalimientacion}}</p>
            </template>
            <p role="alert" v-if="retro === '¡Muy bien!'" class="animated fadeInUp green">{{retro}}</p>
          </div>

          <draggable class="drag-container" :move="checkMove" v-model="listDrag" :options="{group:'opciones'}">
            <div class="drag-elems back-red hvr-grow" v-for="element in listDrag">
              {{element.name}}
            </div>
          </draggable>
        </v-flex>
      </v-layout>
    </div>
    <!-- Retroalimentacion -->

    <v-dialog v-model="retroAct" width="600" height="200">
      <v-card>
        <v-flex xs12 text-xs-right>
          <ui-simple-lsc @hideVideo="hideVideo" :vidTittle="'¡Muy bien!'" videoEmbed="ADMINISTRACIONDINERO11Retroalimentacion (ant42).mp4"></ui-simple-lsc>
        </v-flex>
        <div class="text-xs-center">
          <image-app class="animated fadeInLeft" :imaSize="50" imaSrc="logos-icons/ok-bullet" imaAlt=""></image-app>
        </div>
        <v-card-text>
          Para tomar decisiones efectivas y alcanzar las metas es importante saber administrar el dinero.
        </v-card-text>
        <v-flex text-xs-center>
              <ui-button class="mt-2 mb-4" :content="'Cerrar'" :aria="'asdasd'" @click.native="retroAct = false">
              </ui-button>
            </v-flex>
      </v-card>
    </v-dialog>
    <br>
    <act-drag-back></act-drag-back>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: {
    draggable
  },
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      retroAct: false,
      checkPrue: false,
      droppers: [[], [], []],
      timesAct: 0,
      finalizado: false,
      visto: false,
      retro: "",
      respuesta: ["mal", "mal", "mal" ],
      listaDrop: [
        "1. Destinar un porcentaje adicional de su salario mensual como ahorro fijo para la cuota inicial de su casa.",
        "2. Invertir en un CDT que le genere un interés adicional.",
        "3. Firmar una promesa de compraventa de la casa que desea con una constructora o fiduciaria."
      ],
      listOri: [
        {
          name: "Eficaz",
          numRes: 1,
          retroalimientacion: "Incorrecto. Recuerde que para ser eficaz es importante maximizar los recursos con los que se cuenta.",
          resp: "mal"
        },
        {
          name: "Efectiva",
          numRes: 2,
          retroalimientacion: "Incorrecto. Recuerde que ser efectivo implica asegurarse de causar el impacto deseado.",
          resp: "mal"
        },
        {
          name: "Eficiente",
          numRes: 0,
          retroalimientacion: "Incorrecto. Recuerde que para ser eficiente es importante hacer lo que se debe hacer.",
          resp: "mal"
        }
      ],
      listDrag: []
    };
  },
  methods: {
    hideVideo(){},
    checkact() {
      var pruebaCorrecta = this.respuesta.every(function(elem) {
        return elem === "bien";
      });
      if(pruebaCorrecta){
        this.retroAct = true
        this.$store.commit("nextShow", true);
      }
    },
    checkMove(event) {
      for (var index = 0; index < this.droppers.length; index++) {
        if (
          event.relatedContext.list == this.droppers[index] &&
          event.draggedContext.element.numRes == index
        ) {
          this.retro = "¡Muy bien!";
          event.draggedContext.element.resp = "bien";
          this.respuesta[event.draggedContext.element.numRes] = "bien";
          this.checkact();
          break;
        } else {
          event.draggedContext.element.resp = "mal";
          this.respuesta[event.draggedContext.element.numRes] = "mal";
          this.retro = event.draggedContext.element;
          this.checkact();
        }
      }
    },
  },
  mounted() {
    this.listDrag = this.listOri;
    this.$store.commit("nextShow", false);
  }
};
</script>

<style lang="scss" scoped>
@import "../../../sass/helpers/variables";
.table-drop-act {
  .flex {
    border: solid 1px #ccc;
  }
  .drop {
    width: 100%;
    height: 100%;
    min-height: 70px;
    font-weight: bold;
    cursor: pointer;
  }
}
.drag-container {
  border: solid 2px $primary-red;
  width: 100%;
  max-width: 300px;
  min-height: 200px;
  margin: auto;
  border-radius: 7px;
  .drag-elems{
    cursor: pointer;
    text-align: center;
    width: 100%;
    max-width: 250px;
    display: inline-block;
    margin: 10px 5px;
    padding: 10px;
    color: white;
  }
}

.application.theme--light {
  &.light {
    .table-drop-act {
      .layout:nth-child(odd) {
        background-color: #f7f1e7;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// davivienda-11.vue?182cc408